export default __webpack_public_path__ + "static/2179-477d2edf3642a6ea639f44ccfa932b12.gif";